import { render, staticRenderFns } from "./SOSContacts.vue?vue&type=template&id=75d71dbe&scoped=true&"
import script from "./SOSContacts.vue?vue&type=script&lang=js&"
export * from "./SOSContacts.vue?vue&type=script&lang=js&"
import style0 from "./SOSContacts.vue?vue&type=style&index=0&id=75d71dbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d71dbe",
  null
  
)

export default component.exports